import React from 'react';

import { Navigate } from 'react-router-dom';
import Route from 'enum/route.enum';
import BaseWeatherComponent from 'components/weather/BaseWeatherComponent';
import { Container, RowContainer, ContainerModal, Header } from 'components/styles/Common.styled';

import BackCursor from 'components/common/nav/backCursor';
import { translate as t } from 'utils/i18n';

class weather extends BaseWeatherComponent {
  render() {
    if (this.state.redirectBack) {
      return <Navigate to={Route.route.LANDING} />;
    }
    return (
      <div>
        <Header></Header>
        <BackCursor></BackCursor>
        <Container>
          {this.state.items !== null && this.state.items.length > 0 && (
            <ContainerModal>
              {this.state.items && <RowContainer>{this.renderWeatherData()}</RowContainer>}
            </ContainerModal>
          )}
          {!this.state.loading && this.state.items === null && (
            <div className={'has-text-danger'}>
              <div className={`has-text-danger has-text-centered`}>
                <p className={'is-size-4 has-text-bold'}>{t('Weather.weather_error')}</p>
              </div>
            </div>
          )}
          {this.state.loading && <div className={'is-size-4'}></div>}
        </Container>
      </div>
    );
  }
}

export default weather;
